import { render, staticRenderFns } from "./TemplateDrawer.vue?vue&type=template&id=01b76a06&scoped=true"
import script from "./TemplateDrawer.vue?vue&type=script&lang=js"
export * from "./TemplateDrawer.vue?vue&type=script&lang=js"
import style0 from "./TemplateDrawer.vue?vue&type=style&index=0&id=01b76a06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b76a06",
  null
  
)

export default component.exports